import { getHeaderText } from "@routes/Article/components/ArticleSubshare/helpers";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";

export type HeaderProps = LambdaResponsePayload;

export default function Header({
  data: { responseType },
}: HeaderProps): React.ReactElement {
  return (
    <h1 className="mb-3 font-poppins text-4xl font-semibold text-black">
      {getHeaderText(responseType)}
    </h1>
  );
}
